<div class="container-fluid">
  <div class="row gy-1">
    <div class="col-lg-7 col-md-7 footer-copyright">
      <p class="mb-0 f-light f-w-500">Safe and Confidence© y el logotipo de Safe and Confidence© son una marca registrada</p>
    </div>
<!--    <div class="col-lg-3 col-md-5 text-center">-->
<!--      <div class="d-flex">-->
<!--        <app-language></app-language>-->
<!--        <div class="lang-title f-light f-w-500">-->
<!--          <app-feather-icons [class]="'me-1'" [icons]="'globe'"></app-feather-icons>-->
<!--          <span>Select Region</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
